type BaseState = {
  isLoading: unknown;
  error: unknown;
};

type ByIdState = BaseState & {
  byId: unknown;
  data: unknown;
  apiKind?: unknown;
};

// Distribute over state unions to preserve the link between apiKind and its collections.
type ByIdSelection<T extends ByIdState> = T extends unknown
  ? Pick<T, 'byId' | 'data' | 'isLoading' | 'error'> & {
      apiKind: 'apiKind' extends keyof T ? T['apiKind'] : undefined;
    }
  : never;

export function selectBase<T extends BaseState>(
  state: T,
): { isLoading: T['isLoading']; error: T['error'] } {
  return {
    isLoading: state.isLoading,
    error: state.error,
  };
}

export function selectData<T extends { data: unknown } & BaseState>(
  state: T,
): { data: T['data'] } & ReturnType<typeof selectBase<T>> {
  return {
    ...selectBase(state),
    data: state.data,
  };
}

export function selectByKey<T extends { byKey: unknown; data: T['data'] } & BaseState>(
  state: T,
): { byKey: T['byKey']; data: T['data'] } & ReturnType<typeof selectBase<T>> {
  return {
    ...selectBase(state),
    data: state.data,
    byKey: state.byKey,
  };
}

export function selectById<T extends ByIdState>(state: T): ByIdSelection<T>;

export function selectById(state: ByIdState) {
  return {
    ...selectBase(state),
    apiKind: state.apiKind,
    data: state.data,
    byId: state.byId,
  };
}

export function selectIsLoading<T extends { isLoading: boolean } & BaseState>(
  state: T,
): T['isLoading'] {
  return state.isLoading;
}

// export function selectByOwnerUri<T extends { byOwnerUri: unknown; data: unknown } & BaseState>(
//   state: T,
// ): { byOwnerUri: T['byOwnerUri']; data: T['data'] } & ReturnType<typeof selectBase<T>> {
//   return {
//     ...selectBase(state),
//     data: state.data,
//     byOwnerUri: state.byOwnerUri,
//   };
// }
